// Knopfinhalt für `Auswahl` mit eigenem Text: ein kurzer Wert statt der Chips aller Wahlen ("2 Ergebnisse", "12.10. – 14.10.2026"),
// damit der Knopf in der Bedienleiste nicht in die Höhe wächst. `Auswahl` zeigt bei `knopfInhalt` sonst keinen Pfeil.
import { Icon } from "../../components/Icon";

export function KompaktWert({ text }: { text: string }) {
  return (
    <>
      <span className="auswahl__wert">
        <span className="auswahl__einzel">{text}</span>
      </span>
      <Icon name="chevron-unten" groesse={14} className="auswahl__pfeil" />
    </>
  );
}
